import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription, Subject } from 'rxjs';
import { MegaleiosAlertService } from './megaleios-alert.service';
import { MegaleiosAlert, MegaleiosAlertType } from './megaleios-alert.interface';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-megaleios-alert',
  templateUrl: './megaleios-alert.component.html',
  styleUrls: ['./megaleios-alert.component.scss'],
})
export class MegaleiosAlertComponent implements OnInit, OnDestroy {

  alert: MegaleiosAlert | null = null;
  alertSubscription: Subscription;
  alertInterval: any;

  onDestroy: Subject<void> = new Subject();

  constructor(
    private alertsService: MegaleiosAlertService
  ) { }

  ngOnInit(): void {
    this.alertsService.onAlert()
      .pipe(takeUntil(this.onDestroy))
      .subscribe(alert => {
        if (this.alertInterval) {
          this.alert = null;
          clearTimeout(this.alertInterval);
        }
        this.alert = alert;
        this.alertInterval = setTimeout(() => {
          this.alert = null;
        }, 5000);
      });
  }

  ngOnDestroy(): void {
    this.onDestroy.next();
  }

  cssClass(type: MegaleiosAlertType): string {
    switch (type) {
      case MegaleiosAlertType.Success:
        return 'megaleios-alert-success';
      case MegaleiosAlertType.Error:
        return 'megaleios-alert-error';
    }
  }

}
